import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { DataProvider } from "./components/Dataprovider/Dataprovider";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <DataProvider>
      <BrowserRouter>
        <App/>
      </BrowserRouter>
    </DataProvider>
  </React.StrictMode>
);
